import { Component, computed, input, ViewChild } from '@angular/core';
import {
  AgencyKeys,
  Agent,
  AgentKeys,
  Entity,
  EntityPermissionActivityKeys,
  EntityPermissionModelKeys,
} from '@ag-common-lib/public-api';
import { AgentDispositionModalComponent } from 'ag-common-svc/lib/components/agent-disposition-modal/agent-disposition-modal.component';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { filter, map, mergeMap } from 'rxjs';
import { AgencyService } from 'ag-common-svc/public-api';

@Component({
  selector: 'ag-crm-agency-info',
  templateUrl: './agency-info.component.html',
  styleUrls: ['./agency-info.component.scss'],
})
export class AgencyInfoComponent {
  @ViewChild('agentDispositionModalRef', { static: true })
  agentDispositionModalComponent: AgentDispositionModalComponent;
  agentSig = input.required<Agent>({ alias: 'agent' });

  protected EntityPermissionActivityKeys = EntityPermissionActivityKeys;
  protected readonly EntityPermissionModelKeys = EntityPermissionModelKeys;
  protected readonly Entity = Entity;

  private _mgaIdSig = computed(() => {
    const mgaId = this.agentSig()?.[AgentKeys.p_mga_id];

    return mgaId;
  });
  private _agentIdSig = computed(() => {
    const agentId = this.agentSig()?.[AgentKeys.p_agent_id];

    return agentId;
  });

  private _mgaLeadAgentId$ = toObservable(this._mgaIdSig).pipe(
    filter(Boolean),
    mergeMap(mgaId => {
      return this.agencyService.getAgencyByAgencyId(mgaId);
    }),
    map(mga => {
      return mga?.[AgencyKeys.agencyLead];
    }),
  );
  private _mgaLeadAgentIdSig = toSignal(this._mgaLeadAgentId$);

  isManagerFieldVisibleSig = computed(() => {
    const mgaLeadAgentId = this._mgaLeadAgentIdSig();
    const agentId = this._agentIdSig();

    if (!mgaLeadAgentId) {
      return true;
    }

    return mgaLeadAgentId !== agentId;
  });

  constructor(private agencyService: AgencyService) {}

  async showEditorModal(): Promise<void> {
    this.agentDispositionModalComponent.showPopup(this.agentSig());
  }
}
